"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _core = require("@material-ui/core");

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

var _DrupalLikertNugget = _interopRequireDefault(require("./DrupalLikertNugget.scss"));

var _Image = _interopRequireDefault(require("../../Image/Image"));

var _KESI2Helper = _interopRequireDefault(require("../../../../KESI2/KESI2Helper"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DrupalLikertResultNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalLikertResultNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalLikertResultNugget);

  function DrupalLikertResultNugget(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, DrupalLikertResultNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setBackgroundColorOfTutorial", function (color) {
      var el = document.getElementById('tutorialPaper');

      if (el) {
        if (color) {
          el.style.backgroundColor = color;
        } else {
          var tutorialContent = _KESI2Helper["default"].getTutorial();

          el.style.backgroundColor = tutorialContent.backgroundColor ? tutorialContent.backgroundColor : 'white';
        }
      }

      var buttonEl = document.getElementById('wizardNextButton');

      if (buttonEl) {
        if (color) {} else {
          var _tutorialContent = _KESI2Helper["default"].getTutorial();

          el.style.backgroundColor = _tutorialContent.backgroundColor ? _tutorialContent.backgroundColor : 'white';
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkUniversalPathes", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var nugget, paths, pathValues, biggestValueName, biggestValueText, biggestValueImgPath, biggestValue, biggestValueUuid, isSurveyComplete, getComputedValue, allTopics, demoValues, isDemoMode, dataStorePath, currentSetDataStoreValue, updateValue;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              nugget = _this.state.content[_this.props.id];
              paths = nugget.dataStorePaths;
              pathValues = [];
              biggestValueName = '';
              biggestValueText = '';
              biggestValueImgPath = '';
              biggestValue = 0;
              biggestValueUuid = '';
              isSurveyComplete = true;

              if (paths && paths.length > 0) {
                paths.forEach(function (path) {
                  if (path.value) {
                    var value = _DataStore["default"].getElementByPathImmediately(path.value);

                    if (!value) {
                      isSurveyComplete = false;
                    } else {
                      pathValues.push(value);
                    }
                  }
                });
              }

              if (!isSurveyComplete) {
                _context.next = 41;
                break;
              }

              getComputedValue = function getComputedValue(topics) {
                var topicsValue = 0;
                topics.forEach(function (topic) {
                  var singleTopicValue = 1;
                  pathValues.forEach(function (path) {
                    singleTopicValue = path.hasOwnProperty(topic) ? singleTopicValue * (0, _parseInt2["default"])(path[topic]) : singleTopicValue;
                  });
                  topicsValue = topicsValue + singleTopicValue;
                });
                return topicsValue;
              };

              allTopics = nugget.topics;
              demoValues = {
                topicText: '',
                topicName: '',
                topicImgPath: '',
                uuid: ''
              };
              allTopics.forEach(function (topic, index) {
                var topicText = topic.topicText;
                var topicName = topic.topicName;
                var topicImgPath = topic.topicImage;
                var topicUuid = topic.uuid;
                var topicsToCompute = [];

                for (var i = 0; i < (0, _parseInt2["default"])(topic.numberOfLikertQuestions); i++) {
                  topicsToCompute.push("".concat(topicName).concat(i + 1));
                }

                var topicValue = getComputedValue(topicsToCompute);

                if (topicName === 'ernaehrung') {
                  demoValues.topicText = topicText;
                  demoValues.topicName = topicName;
                  demoValues.topicImgPath = topicImgPath;
                  demoValues.topicUuid = topicUuid;
                }

                if (index === 0) {
                  biggestValue = topicValue;
                  biggestValueName = topicName;
                  biggestValueText = topicText;
                  biggestValueImgPath = topicImgPath;
                  biggestValueUuid = topicUuid;
                } else {
                  if (topicValue > biggestValue) {
                    biggestValue = topicValue;
                    biggestValueName = topicName;
                    biggestValueText = topicText;
                    biggestValueImgPath = topicImgPath;
                    biggestValueUuid = topicUuid;
                  } else if (topicValue === biggestValue) {
                    var rnd = Math.random();

                    if (rnd > 0.5) {
                      biggestValue = topicValue;
                      biggestValueName = topicName;
                      biggestValueText = topicText;
                      biggestValueImgPath = topicImgPath;
                      biggestValueUuid = topicUuid;
                    }
                  }
                }
              });
              isDemoMode = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_DEMO_MODE);

              if (isDemoMode) {
                biggestValueImgPath = demoValues.topicImgPath;
                biggestValueText = demoValues.topicText;
                biggestValueName = demoValues.topicName;
                biggestValueUuid = demoValues.topicUuid;
              }

              console.log('likertresultnugget', nugget);
              dataStorePath = nugget.dataStorePath;
              currentSetDataStoreValue = _DataStore["default"].getElementByPathImmediately(dataStorePath);

              if (!(biggestValueName !== _this.state.currentTopic && (currentSetDataStoreValue && currentSetDataStoreValue.name !== 'calculating' || !currentSetDataStoreValue))) {
                _context.next = 35;
                break;
              }

              _context.next = 23;
              return _DataStore["default"].setSingleData(dataStorePath, {
                name: 'calculating'
              });

            case 23:
              _this.setState({
                loading: true
              });

              _context.next = 26;
              return (0, _TimeoutHelper.timeout)(3000);

            case 26:
              _this.setState({
                loading: false
              });

              _this.setState({
                currentTopic: biggestValueName,
                currentTopicText: biggestValueText,
                currentTopicImagePath: biggestValueImgPath
              });

              _context.next = 30;
              return _DataStore["default"].setSingleData(dataStorePath, {
                name: biggestValueName,
                text: biggestValueText,
                imgPath: biggestValueImgPath,
                uuid: biggestValueUuid
              });

            case 30:
              updateValue = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE) || 0;
              _context.next = 33;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE, updateValue + 1);

            case 33:
              _context.next = 41;
              break;

            case 35:
              if (!(currentSetDataStoreValue && currentSetDataStoreValue.name !== 'calculating')) {
                _context.next = 41;
                break;
              }

              _this.setState({
                loading: true
              });

              _context.next = 39;
              return (0, _TimeoutHelper.timeout)(3000);

            case 39:
              _this.setState({
                loading: false
              });

              _this.setState({
                currentTopic: biggestValueName,
                currentTopicText: biggestValueText,
                currentTopicImagePath: biggestValueImgPath
              });

            case 41:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _this.state = _objectSpread({
      loading: true,
      currentTopic: null,
      currentTopicText: null
    }, _this.state); // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor
    // move out of here

    return _this;
  }

  (0, _createClass2["default"])(DrupalLikertResultNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nugget = this.state.content[this.props.id];
      console.log('likertresultnugget', nugget, this.props);

      if (nugget && nugget.backgroundColor) {
        this.setBackgroundColorOfTutorial(nugget.backgroundColor);
      }

      this.checkUniversalPathes();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      +this.setBackgroundColorOfTutorial();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalLikertResultNugget.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalLikertResultNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
    }
  }, {
    key: "render",
    value: function render() {
      var nugget = this.state.content[this.props.id];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: 'likertResultContainer',
        style: {
          width: '100%',
          height: '450px',
          position: 'relative',
          textAlign: 'center'
        }
      }, this.state.loading ? nugget.loadingText && /*#__PURE__*/_react["default"].createElement("div", {
        className: 'loadingText',
        style: {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", null, nugget.loadingText), /*#__PURE__*/_react["default"].createElement(_core.CircularProgress, null)) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "topicText ".concat(_DrupalLikertNugget["default"].topicText),
        dangerouslySetInnerHTML: {
          __html: nugget.resultText.replace('---RESULTTEXT---', this.state.currentTopicText)
        }
      }), this.state.currentTopicImagePath ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "topic image",
        className: "topicImage ".concat(_DrupalLikertNugget["default"].topicImage),
        src: "".concat(this.props.path).concat(this.state.currentTopicImagePath)
      }) : null));
    }
  }]);
  return DrupalLikertResultNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalLikertResultNugget;
DrupalLikertResultNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  forcedUIColor: _propTypes["default"].string,
  renderIcon: _propTypes["default"].func.isRequired,
  registerSendFunc: _propTypes["default"].func,
  setTutorialBackgroundColor: _propTypes["default"].func
};
DrupalLikertResultNugget.defaultProps = {
  id: null
};